import React, { Component } from 'react';
import { Modal, Spin, Input, message } from 'antd';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

const { TextArea } = Input;

class Cancel extends Component {
    state = {
        record: {},
        data: {},
        visible: false,
        loading: false,
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        });
    }
    
    hide = () => {
        this.setState({
            data: {},
            visible: false,
        });
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        data[key] = value;
        this.setState({ data });
    }

    submit = () => {
        const { record } = this.props;
        const { data } = this.state;
        const { complaintRecordId } = record;

        if (!data.backReason) {
            return message.warning('请填写拒绝理由');
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.qualityManagement.updateIsCompleted, {
            complaintRecordId,
            isCompleted: 52,
            ...data,
        }).then(res => {
            const { success } = res;
            message.success(success);
            this.hide();
            this.setState({ loading: false }, () => {
                this.props.update();
            });
        }).catch(err => {
            this.setState({ loading: false });
        });
    }

    render() {
        const { loading, visible, data } = this.state;
        return (
            <Modal
                title="打回"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                maskClosable={false}
                confirmLoading={loading}
                width="460px"
            >
                <Spin spinning={loading} style={{padding:'10px 20px 10px'}}>
                    <div style={{ textAlign: 'center', fontSize: '14px' }}>
                        打回
                    </div>
                    <div style={{margin:'10px 0 10px'}}>
                        <TextArea
                            rows={5}
                            placeholder='请填写拒绝理由'
                            value={data.backReason}
                            onChange={e => this.handleChange(e.target.value, 'backReason')}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}

export default Cancel;


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/Cancel.js